import { AccountCircle } from "@mui/icons-material";
import { AppBar, Toolbar, IconButton, Grid2 as Grid, Typography, Box } from "@mui/material";
import React from "react";
import MenuIcon from '@mui/icons-material/Menu';
import { ui } from "../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";
import "./index.css"
import { getMarketingSource, getMarketingSourceClass as getMarketingSourceBackgroundColourClass } from "./helpers";

type MiddleBarProps = {
    menuId: string;
    setAnchorMainEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
    setAnchorCustomerMenuEl: React.Dispatch<React.SetStateAction<HTMLElement | null>>;
}

const MiddleBar: React.FC<MiddleBarProps> = ({ menuId, setAnchorCustomerMenuEl, setAnchorMainEl }) => {
    const [localDirectory, setLocalDirectory] = React.useState("");
    const callCampaign = useAppSelector(({ ui }) => ui.CallCampaign)
    const accountCode = useAppSelector(({ state }) => state.Account)
    const callTo = useAppSelector(({ ui }) => ui.CallTo)
    const callFrom = useAppSelector(({ ui }) => ui.CallFrom)
    const callerName = useAppSelector(({ ui }) => ui.CallerName)

    const callerInfo = useAppSelector(({ ui }) => ui.CallerInfo)
    const callInfo = useAppSelector(({ ui }) => ui.CallInfo)

    const handleMainMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorMainEl(event.currentTarget);
        ui.MainMenuModal = true
    };

    const handlePropertyMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorCustomerMenuEl(event.currentTarget);
        ui.CustomerNameInputModal = true
    };

    React.useEffect(() => {
        ui.CallInfo = `${callCampaign ? callCampaign : ""} (${accountCode?.accountCode}) - ${callTo ? callTo : ""}`
        setLocalDirectory(getMarketingSource(accountCode?.directoryTypeId))
    }, [callCampaign, callTo, accountCode])

    React.useEffect(() => {
        ui.CallerInfo = `${callerName ? callerName : "Caller"} - ${callFrom ? callFrom : ""}`
    }, [callFrom, callerName])


    return (
        (<AppBar position="static" sx={{
            backgroundColor: " #3838d0 !important",
            color: " #fff!important"
        }}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={handleMainMenuOpen}
                    size="large"
                    sx={(theme) => ({ marginRight: theme.spacing(2) })}
                >
                    <MenuIcon />
                </IconButton>
                <Grid container direction="column">
                    <Grid>
                        <Typography sx={(theme) => ({
                            display: 'none',
                            [theme.breakpoints.up('sm')]: {
                                display: 'block',
                            },
                        })} variant="h6" noWrap>
                            {callInfo}
                        </Typography>
                        {localDirectory && <span className={`local-dir ${getMarketingSourceBackgroundColourClass(accountCode?.directoryTypeId)}`}>{localDirectory}</span>}
                    </Grid>
                    <Grid>
                        <Typography sx={(theme) => ({
                            display: 'none',
                            [theme.breakpoints.up('sm')]: {
                                display: 'block',
                            },
                        })} variant={'caption'} noWrap>
                            {callerInfo}
                        </Typography>
                    </Grid>
                </Grid>
                <div style={{ flexGrow: 1 }} />
                <Box sx={(theme) => ({
                    display: 'none',
                    [theme.breakpoints.up('md')]: {
                        display: 'flex',
                    }
                })} >
                    < IconButton
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={handlePropertyMenuOpen}
                        color="inherit"
                        size="large">
                        <AccountCircle />
                    </IconButton>
                </Box>
            </Toolbar >
        </AppBar >)
    );
}

export default React.memo(MiddleBar);